import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Course, CourseRegistry } from '../types';

const initialState: CourseRegistry = {};

const coursesSlice = createSlice({
  name: 'courses',
  initialState,
  reducers: {
    setCourses: (_state, action: PayloadAction<CourseRegistry>) => {
      return action.payload;
    },
    addCourse: (state, action: PayloadAction<{ courseId: string; course: Course }>) => {
      const { courseId, course } = action.payload;
      state[courseId] = course;
    },
  },
});

export const { setCourses, addCourse } = coursesSlice.actions;
export default coursesSlice.reducer;
